import Image from '@/assets/images/panama.jpg';

export default {
  slogan: '¡ Pronto estaremos más cerca de tí !',
  contactUs: 'Contáctanos aquí',
  firstTitle: {
    text: '¿Qué somos?',
  },
  secondTitle: {
    text: '¿Quiénes somos?',
    sub: 'El lado más humano',
  },
  thirdTitle: {
    text: 'Nuestros Servicios',
  },
  fourthTitle: {
    text: 'Aliados & Colaboradores',
    sub: 'Una mano amiga en todo momento',
  },
  fifthTitle: {
    text: 'Nuestra ubicación',
    sub: 'Estamos muy cerca de tí',
  },
  linksTitle: {
    text: 'Enlances de Interés',
    sub: 'Para mayor información',
  },
  firstQuote: 'Los panameños y los extranjeros son iguales ante la Ley…',
  secondQuote: 'Los panameños y los extranjeros son iguales ante la Ley…',
  companyInfo: [
    {
      image: Image,
      title: 'Nuestra Misión',
      subtitle: 'Subtitulo opcional',
      text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad aliquam a incidunt fuga, ducimus nisi iusto ipsum sit deleniti suscipit atque aliquid, velit at? At quasi magni voluptates molestiae aperiam',
    },
    {
      image: Image,
      title: 'Nuestra Visión',
      subtitle: 'Subtitulo opcional',
      text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad aliquam a incidunt fuga, ducimus nisi iusto ipsum sit deleniti suscipit atque aliquid, velit at? At quasi magni voluptates molestiae aperiam',
    },
    {
      image: Image,
      title: 'Nuestros Objetivos',
      subtitle: 'Subtitulo opcional',
      text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad aliquam a incidunt fuga, ducimus nisi iusto ipsum sit deleniti suscipit atque aliquid, velit at? At quasi magni voluptates molestiae aperiam',
    },
  ],
  services: ['Trabajo', 'Administrativo', 'Comercial', 'Procesal', 'Penal Corporativo', 'Otros'],
  officeInfo: [
    {
      textUp: 'Calle 55 Obarrio - Edificio SFC',
      textBottom: 'Piso 22 - Oficina C',
      icon: 'map-marked-alt',
      iconType: 'fas',
      size: 'left',
      delay: 200,
    },
    {
      textUp: 'Lunes - Viernes',
      textBottom: '08:00 AM - 05:00 PM',
      icon: 'calendar-week',
      iconType: 'fas',
      size: 'right',
      delay: 400,
    },
    {
      textUp: '+(507) 209 - 4298',
      textBottom: '+(507) 209 - 4297',
      icon: 'phone-alt',
      iconType: 'fas',
      size: 'left',
      delay: 600,
    },
    {
      link: 'info@bgsestudiojuridico.com',
      icon: 'paper-plane',
      iconType: 'fas',
      size: 'right',
      delay: 600,
    },
  ],
  language_picker_helper: 'Escoge un idioma',
  languages: {
    spanish: 'Español',
    english: 'Ingles',
  },
};
